<rwidget-alert></rwidget-alert>
<div class="bg-white px-4 md:p-8" *ngIf="ticket$ | async; let ticket">
    <div class="vl-app-light:block md:flex xl:mx-auto xl:max-w-5xl" #mainContainer>
        <header
            class="vl-app-light:border-b vl-app-light:mr-0 vl-app-light:flex-row vl-app-light:justify-between flex flex-1 justify-between border-0 border-b border-solid border-black border-opacity-10 py-4 dark:border-contrast-yellow md:my-0 md:mr-8 md:flex-col md:justify-start md:border-b-0 xl:mr-16">
            <a
                class="vl-app-light:flex orb-app-light-dark:text-secondary gl-light:text-secondary flex w-9 flex-col justify-center text-primary md:hidden"
                [routerLink]="'/account/tickets' | localize"
                [queryParams]="isHistoryTicket ? { isHistory: true } : { checkTicketsForCertainTime: true }">
                <ion-icon
                    class="mr-1 text-xl dark:filter-yellow"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg"></ion-icon>
            </a>
            <h1
                class="vl-app-light:text-base vl-app-light:font-bold flex flex-col justify-center text-center text-base font-semibold md:text-left md:text-[2.75rem] md:font-medium md:leading-[3rem]">
                {{ 'TICKET_DETAILS' | translate }}
            </h1>
            <button
                class="vl-app-light:flex orb-app-light-dark:text-secondary gl-light:text-secondary flex w-9 flex-col justify-center text-primary dark:filter-yellow md:hidden"
                [attr.aria-label]="'DOWNLOAD_TICKET' | translate"
                [disabled]="(isOnline$ | async) === false"
                (click)="downloadPdf(ticket)">
                <mat-icon [ngClass]="{ invisible: (isOnline$ | async) === false }" svgIcon="ticket-download"></mat-icon>
            </button>
            <a
                class="vl-app-light:hidden mt-8 hidden items-center border-0 border-t border-solid border-black border-opacity-10 dark:border-contrast-yellow md:flex md:py-3"
                [routerLink]="'/account/tickets' | localize">
                <div class="gl-light:text-secondary flex w-9 flex-col justify-center text-primary">
                    <mat-icon svgIcon="ticket-back"></mat-icon>
                </div>
                {{ 'LOCAL_BTN_BACK' | translate }}
            </a>
        </header>
        <main class="vl-app-light:w-full md:w-[26rem] xl:flex xl:w-[44rem]" #ticketContainer>
            <rwidget-ticket-details
                class="md:w-full xl:mr-4 xl:w-[26rem]"
                *ngIf="!env.TICKET_LIST_V2_ENABLED"
                [ticket]="ticket"
                [isHistoryTicket]="isHistoryTicket"
                [isRecentlyUsed]="isRecentlyUsedTicket"
                [parentRef]="env.IS_MOBILE_APP ? mainContainer : ticketContainer"
                (refreshTickets)="updateTicketsCache()"
                (handleBuyAgain)="buyTicketAgain($event)"></rwidget-ticket-details>
            <rwidget-ticket-details-v3
                class="md:w-full xl:mr-4 xl:w-[26rem]"
                *ngIf="env.TICKET_LIST_V2_ENABLED && env.IS_NEW_AFC"
                [ticket]="ticket"
                [isHistoryTicket]="isHistoryTicket">
            </rwidget-ticket-details-v3>

            <rwidget-ticket-details-v2
                class="md:w-full xl:mr-4 xl:w-[26rem]"
                *ngIf="env.TICKET_LIST_V2_ENABLED && !env.IS_NEW_AFC"
                [ticket]="ticket"
                [isHistoryTicket]="isHistoryTicket">
            </rwidget-ticket-details-v2>
            <section class="vl-app-light:hidden hidden pb-4 md:block xl:flex-1">
                <a
                    class="flex cursor-pointer items-center hover:no-underline active:no-underline"
                    *ngIf="ticket.cardType !== cardType.GLOBAL"
                    [disabled]="(isOnline$ | async) === false"
                    (click)="downloadPdf(ticket)">
                    <div class="flex w-9 flex-col justify-center text-primary">
                        <mat-icon
                            [ngClass]="{ invisible: (isOnline$ | async) === false }"
                            svgIcon="ticket-download"></mat-icon>
                    </div>
                    {{ 'DOWNLOAD_TICKET' | translate }}
                </a>
            </section>
        </main>
    </div>
</div>
